import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { format } from "date-fns";
import { Pencil, Save, X } from "lucide-react";

interface NoteItemProps {
  note: {
    id: string;
    note: string;
    created_at: string;
    is_response: boolean;
  };
  isEditing: boolean;
  editedContent: string;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
  onEditChange: (content: string) => void;
}

export const NoteItem = ({
  note,
  isEditing,
  editedContent,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  onEditChange,
}: NoteItemProps) => {
  return (
    <div
      className={`p-4 rounded-lg ${
        note.is_response ? "bg-blue-900/20" : "bg-gray-900/50"
      }`}
    >
      {isEditing ? (
        <div className="space-y-2">
          <Textarea
            value={editedContent}
            onChange={(e) => onEditChange(e.target.value)}
            className="min-h-[100px]"
          />
          <div className="flex gap-2">
            <Button
              size="sm"
              onClick={onSave}
              className="flex items-center gap-2"
            >
              <Save className="h-4 w-4" />
              Save
            </Button>
            <Button
              size="sm"
              variant="outline"
              onClick={onCancel}
              className="flex items-center gap-2"
            >
              <X className="h-4 w-4" />
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          <div className="flex justify-between items-start">
            <p className="text-sm text-gray-400">
              {format(new Date(note.created_at), "PPp")}
              {note.is_response && " (Client Response)"}
            </p>
            <div className="flex gap-2">
              <Button
                size="sm"
                variant="ghost"
                onClick={onEdit}
                className="h-8 w-8 p-0"
              >
                <Pencil className="h-4 w-4" />
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={onDelete}
                className="h-8 w-8 p-0 text-red-500 hover:text-red-400"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <p className="text-white whitespace-pre-wrap">{note.note}</p>
        </div>
      )}
    </div>
  );
};